import { render, staticRenderFns } from "./BillingsList.vue?vue&type=template&id=578bc14b"
import script from "./BillingsList.vue?vue&type=script&lang=js"
export * from "./BillingsList.vue?vue&type=script&lang=js"
import style0 from "./BillingsList.vue?vue&type=style&index=0&id=578bc14b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports